import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useDeviceValidationSchema = () => {
  const { t } = useTranslation();

  return Yup.object({
    serial: Yup.string()
      .required(t('pages.devices.serialRequired'))
      .matches(/^\d{1,7}$/, t('pages.devices.serialInvalid'))
      .matches(/^[^<>]*$/, t('pages.devices.serialInvalidCharacters')),
    device_number: Yup.string()
      .matches(/^[a-zA-Z0-9-]*$/, t('pages.devices.deviceNumberInvalid'))
      .matches(/^[^<>]*$/, t('pages.devices.deviceNumberInvalidCharacters')),
    model: Yup.number()
      .typeError(t('pages.devices.modelInvalid'))
      .required(t('pages.devices.modelRequired')),
    structure_version: Yup.string()
      .required(t('pages.devices.structureRequired'))
      .matches(/^[^<>]*$/, t('pages.devices.structureInvalidCharacters')),
    password: Yup.string().matches(
      /^[^<>]*$/,
      t('pages.devices.password_invalid_characters')
    ),
  });
};
